import { Box, useTheme } from '@mui/material'

import { ModalWrapper } from 'src/components'

import { useStyles } from '../styles'

interface IProps {
  open: boolean
  handleClose: () => void
}

export const HowDoesItWorksModal = ({ open, handleClose }: IProps) => {
  const theme = useTheme()
  const classes = useStyles()

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.verifyModal}>
      <Box
        sx={{
          width: 'auto',
          maxWidth: '350px',
          height: '70dvh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: '15px',
        }}
      >
        <video
          style={{
            width: 'auto',
            maxWidth: '350px',
            height: '100%',
            maxHeight: '70dvh',
            borderRadius: '8px',
          }}
          controls
          autoPlay
          muted
        >
          <source
            src="https://s3.eu-central-1.amazonaws.com/cdn-dev.trackgood.io/how_does_it_works_bb7c071b.MOV"
            type="video/mp4"
          />
        </video>
      </Box>
      {/* 
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: '10px',
          pb: '5px',
        }}
      >
        <Button onClick={handleClose} variant="contained" size="small">
          <HelperWrapper t="scan-to-earn-back-button-label" isColorInherited />
        </Button>
      </Box> */}
    </ModalWrapper>
  )
}
